"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = (0, _memoizeOne.default)(function (keyCodeMap) {
  return function (e) {
    var action = keyCodeMap[e.keyCode];

    if (!action) {
      return;
    }

    action();
  };
});

exports.default = _default;